export interface ChargeWaiverEntity {

    id?: number | null,
    seqNo?: number | null,
    cntrNo?: string | null,
    waiverReason?: string | null,
    chargeType?: string | null,
    subChargeType?: string | null,
    status?: string | null,
    size?: number | null,
    type?: string | null,
    billToCompany?: string | null,
    chargeOnCompany?: string | null,
    consortiumCode?: string | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    customerName?: string | null,
    etd?: Date | null,
    cntrTypeGrp?: string | null,
    serviceOrdCode?: string | null,
    tariffType?: string | null,
    tariffCode?: string | null,
    chrfrmDate?: Date | null,
    chgToDate?: Date | null,
    qty?: number | null,
    uom?: string | null,
    opsLine?: string | null,
    truckerName?: string | null,
    cnicNo?: string | null,
    vehicleNo?: string | null,
    damageType?: string | null,
    amount?: number | null,
    remark?: string | null,
    commodityCode?: string | null,
    forwarderCode?: string | null,
    customerGroup?: string | null,
    examFlag?: string | null,
    batNo?: string | null,
    paidThroughDate?: Date | null,
    remark1?: string | null,
    remark2?: string | null,
    reasonForRecommendation?: string | null,
    initiatedBy?: string | null,
    initiatedDate?: Date | null,
    waiverApprovedBy?: string | null,
    waiverApprovedDatetime?: Date | null,
    waiverNoOfDays?: number | null,
    waiverPercentage?: number | null,
    exceptionMsg?: string | null,
    waiverType?: string | null,
    tierNo?: number | null,
    tierFromDate?: Date | null,
    tierToDate?: Date | null,
    allowUpdateFromDate?: string | null,
    allowUpdateToDate?: string | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_CHARGE_WAIVER_DETAIL_ENTITY: ChargeWaiverEntity = {

    id: 0,
    seqNo: null,
    cntrNo: null,
    waiverReason: null,
    chargeType: null,
    subChargeType: null,
    status: null,
    size: null,
    type: null,
    billToCompany: null,
    chargeOnCompany: null,
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    customerName: null,
    etd: null,
    cntrTypeGrp: null,
    serviceOrdCode: null,
    tariffType: null,
    tariffCode: null,
    chrfrmDate: null,
    chgToDate: null,
    qty: null,
    uom: null,
    opsLine: null,
    truckerName: null,
    cnicNo: null,
    vehicleNo: null,
    damageType: null,
    amount: null,
    remark: null,
    commodityCode: null,
    forwarderCode: null,
    customerGroup: null,
    examFlag: null,
    batNo: null,
    paidThroughDate: null,
    remark1: null,
    remark2: null,
    reasonForRecommendation: null,
    initiatedBy: null,
    initiatedDate: null,
    waiverApprovedBy: null,
    waiverApprovedDatetime: null,
    waiverNoOfDays: null,
    waiverPercentage: null,
    exceptionMsg: null,
    waiverType: null,
    tierNo: null,
    tierFromDate: null,
    tierToDate: null,
    allowUpdateFromDate: null,
    allowUpdateToDate: null,
}
